import { supabase } from "@/lib/supabase";
import type { Store } from "@/types";
import { useCallback, useEffect, useState } from "react";

export function useStores() {
	const [stores, setStores] = useState<Store[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	const fetchStores = useCallback(async () => {
		setLoading(true);
		setError(null);
		const { data, error: err } = await supabase
			.from("stores")
			.select("*")
			.order("created_at", { ascending: false });

		if (err) {
			setError(err.message);
		} else {
			setStores(data ?? []);
		}
		setLoading(false);
	}, []);

	useEffect(() => {
		fetchStores();
	}, [fetchStores]);

	return { stores, loading, error, refetch: fetchStores };
}

export function useStore(id: string | undefined) {
	const [store, setStore] = useState<Store | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!id) {
			setLoading(false);
			return;
		}

		async function fetch() {
			setLoading(true);
			const { data, error: err } = await supabase.from("stores").select("*").eq("id", id).single();

			if (err) {
				setError(err.message);
			} else {
				setStore(data);
			}
			setLoading(false);
		}

		fetch();
	}, [id]);

	return { store, loading, error };
}
